"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var linechart_1 = require("../render/linechart");

var render_utils_1 = require("../render/render_utils");

var dom_1 = require("../util/dom");

function history(container, history, metrics) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var drawArea, plots, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, metric, values, nonValidationMetric, _values, plotNames, options, renderPromises, _i, _plotNames, name, subContainer, series, _values2, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            drawArea = render_utils_1.getDrawArea(container);
            plots = {};
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 5;

            for (_iterator = metrics[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              metric = _step.value;

              if (!/val_/.test(metric)) {
                values = getValues(history, metric, metrics.indexOf(metric));
                initPlot(plots, metric);
                plots[metric].series.push(metric);
                plots[metric].values.push(values);
              } else {
                nonValidationMetric = metric.replace('val_', '');
                initPlot(plots, nonValidationMetric);
                _values = getValues(history, metric, metrics.indexOf(metric));
                plots[nonValidationMetric].series.push(metric);
                plots[nonValidationMetric].values.push(_values);
              }
            }

            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 13:
            _context.prev = 13;
            _context.prev = 14;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 16:
            _context.prev = 16;

            if (!_didIteratorError) {
              _context.next = 19;
              break;
            }

            throw _iteratorError;

          case 19:
            return _context.finish(16);

          case 20:
            return _context.finish(13);

          case 21:
            plotNames = Object.keys(plots);
            options = Object.assign({}, {
              xLabel: 'Iteration',
              yLabel: 'Value'
            }, opts);
            renderPromises = [];

            for (_i = 0, _plotNames = plotNames; _i < _plotNames.length; _i++) {
              name = _plotNames[_i];
              subContainer = dom_1.subSurface(drawArea, name);
              series = plots[name].series;
              _values2 = plots[name].values;

              if (series.every(function (seriesName) {
                return Boolean(seriesName.match('acc'));
              })) {
                if (options.zoomToFitAccuracy) {
                  options.zoomToFit = true;
                } else {
                  options.yAxisDomain = [0, 1];
                  delete options.zoomToFit;
                }
              }

              done = linechart_1.linechart(subContainer, {
                values: _values2,
                series: series
              }, options);
              renderPromises.push(done);
            }

            _context.next = 27;
            return Promise.all(renderPromises);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 9, 13, 21], [14,, 16, 20]]);
  }));
}

exports.history = history;

function initPlot(plot, name) {
  if (plot[name] == null) {
    plot[name] = {
      series: [],
      values: []
    };
  }
}

function getValues(history, metric, metricIndex) {
  if (Array.isArray(history)) {
    var metricHistory = Array.isArray(history[0]) ? history[metricIndex] : history;
    var points = [];

    for (var i = 0; i < metricHistory.length; i++) {
      var log = metricHistory[i];
      points.push({
        x: i,
        y: log[metric]
      });
    }

    return points;
  } else {
    return history.history[metric].map(function (y, x) {
      return {
        x: x,
        y: y
      };
    });
  }
}

function fitCallbacks(container, metrics) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var accumulators = {};
  var callbackNames = opts.callbacks || ['onEpochEnd', 'onBatchEnd'];
  var drawArea = render_utils_1.getDrawArea(container);
  var historyOpts = Object.assign({}, opts);
  delete historyOpts.callbacks;

  function makeCallbackFor(callbackName) {
    var _this = this;

    return function (_, log) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var metricLogs, presentMetrics, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, metric, accumulator, subContainer;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (/batch/i.test(callbackName)) {
                  historyOpts.xLabel = 'Batch';
                } else if (/epoch/i.test(callbackName)) {
                  historyOpts.xLabel = 'Epoch';
                }

                metricLogs = [];
                presentMetrics = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 6;

                for (_iterator2 = metrics[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  metric = _step2.value;

                  if (log[metric] != null) {
                    presentMetrics.push(metric);
                    accumulator = getAccumulator(accumulators, callbackName, metric);
                    accumulator.push(_defineProperty({}, metric, log[metric]));
                    metricLogs.push(accumulator);
                  }
                }

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 14:
                _context2.prev = 14;
                _context2.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 17:
                _context2.prev = 17;

                if (!_didIteratorError2) {
                  _context2.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context2.finish(17);

              case 21:
                return _context2.finish(14);

              case 22:
                subContainer = dom_1.subSurface(drawArea, callbackName, {
                  title: callbackName
                });
                history(subContainer, metricLogs, presentMetrics, historyOpts);
                _context2.next = 26;
                return render_utils_1.nextFrame();

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 10, 14, 22], [15,, 17, 21]]);
      }));
    };
  }

  var callbacks = {};
  callbackNames.forEach(function (name) {
    callbacks[name] = makeCallbackFor(name);
  });
  return callbacks;
}

exports.fitCallbacks = fitCallbacks;

function getAccumulator(accumulators, callback, metric) {
  if (accumulators[callback] == null) {
    accumulators[callback] = {};
  }

  if (accumulators[callback][metric] == null) {
    accumulators[callback][metric] = [];
  }

  return accumulators[callback][metric];
}